import { FormattedMessage } from 'react-intl';
import * as React from 'react';

type TProps = React.ComponentProps<typeof FormattedMessage>;

const T = React.forwardRef<HTMLElement, TProps>((props, _ref) => {
  return <FormattedMessage {...props} />;
});
T.displayName = 'T';

// ESLint doesn't recognize forwardRef components as valid component exports for Fast Refresh

export { T };
